/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'CportalModule';
const componentName = 'threat-intelligence-widget';
const prefix = `${moduleName}.${componentName}`;

export const threatIntelligenceHeader = `${prefix}.threatIntelligenceHeader`;
export const cloudServicesWafManagementLabel = `${prefix}.cloudServicesWafManagementLabel`;
export const signaturesLabel = `${prefix}.signaturesLabel`;
export const receiveNotificationsLabel = `${prefix}.receiveNotificationsLabel`;
export const autoDownloadWafSignaturesLabel = `${prefix}.autoDownloadWafSignaturesLabel`;
export const applicationRulesLabel = `${prefix}.applicationRulesLabel`;
export const autoSyncApplicationRulesDbUpdatesLabel = `${prefix}.autoSyncApplicationRulesDbUpdatesLabel`;
export const autoSyncIpReputationDbUpdatesLabel = `${prefix}.autoSyncIpReputationDbUpdatesLabel`;
export const userAgentDbSyncLabel = `${prefix}.userAgentDbSyncLabel`;
export const enabledLabel = `${prefix}.enabledLabel`;
export const deactivatedLabel = `${prefix}.deactivatedLabel`;

export const ENGLISH = {
    [threatIntelligenceHeader]: 'Threat Intelligence',
    [cloudServicesWafManagementLabel]: 'Cloud Services WAF Management',
    [signaturesLabel]: 'Signatures',
    [receiveNotificationsLabel]: 'Receive notifications when new CRS data is available',
    [autoDownloadWafSignaturesLabel]: 'Auto download WAF Signatures',
    [applicationRulesLabel]: 'Application Rules',
    [autoSyncApplicationRulesDbUpdatesLabel]: 'Auto-sync Application Rules DB updates',
    [autoSyncIpReputationDbUpdatesLabel]: 'Auto-sync IP Reputation DB updates',
    [userAgentDbSyncLabel]: 'User Agent DB Sync',
    [enabledLabel]: 'Enabled',
    [deactivatedLabel]: 'Deactivated',
};
